
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#E4E8F8","fill-rule":"nonzero","d":"M1.099 9.662h9.995v1.432H1.099zM14.906 9.662h9.995v1.432h-9.995zM14.906 23.469h9.995v1.432h-9.995zM1.099 23.469h9.995v1.432H1.099z"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M1.099 1.099h9.995v9.995H1.099zM14.906 1.099h9.995v9.995h-9.995zM1.099 14.906h9.995v9.995H1.099zM14.906 14.906h9.995v9.995h-9.995zM4.25 4.25l3.692 3.692M7.942 4.25L4.251 7.943"}}),_c('path',{attrs:{"stroke":"#204ECF","stroke-linejoin":"round","stroke-width":".5","d":"M17.98 19.619l1.54 1.537 2.306-2.307"}})])])
          )
        }
      }
    